import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'


// NEW RELIC INIT (ADD THIS BLOCK)
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'

// Remaining import statements

const options = {
  "info": {
    "applicationID": 601337070,
    "beacon": "bam.nr-data.net",
    "errorBeacon": "bam.nr-data.net",
    "licenseKey": "NRJS-e0e94f4d04f3dc214e3",
    "sa": 1
  },
  "init": {
    "ajax": {
      "deny_list": [
        "bam.nr-data.net"
      ]
    },
    "browser_consent_mode": {
      "enabled": false
    },
    "distributed_tracing": {
      "enabled": true
    },
    "performance": {
      "capture_detail": false,
      "capture_marks": false,
      "capture_measures": true
    },
    "privacy": {
      "cookies_enabled": true
    }
  },
  "loader_config": {
    "accountID": 7913460,
    "agentID": 601337070,
    "applicationID": 601337070,
    "licenseKey": "NRJS-e0e94f4d04f3dc214e3",
    "trustKey": 7913460
  }
}

// The agent loader code executes immediately on instantiation.
const nrba = new BrowserAgent(options)

if (process.env.REACT_APP_NODE_ENV === 'staging' || process.env.REACT_APP_NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    environment: process.env.REACT_APP_NODE_ENV,
    // Performance Monitoring
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^\//, /^https:\/\/www\.staging.nivaancare\.co.in/],
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
